import React from "react";
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { LoaderIcon } from 'lucide-react';
import { getBaseUrl } from '../utils/api';
interface InsightData {
  subject: string;
  content: string;
  cta_url: string;
  cognito_id?: string;
}
export function InsightPage() {
  const [insightData, setInsightData] = useState<InsightData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Fetch insight data on page load
  useEffect(() => {
    const fetchInsight = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const params = new URLSearchParams(window.location.search);
        const id = params.get('id');
        if (!id) {
          setError('No insight ID provided');
          setIsLoading(false);
          return;
        }
        const baseUrl = getBaseUrl();
        const response = await fetch(`${baseUrl}insight?id=${id}`);
        if (!response.ok) {
          throw new Error('Failed to fetch insight');
        }
        const data = await response.json();
        setInsightData(data);
      } catch (err) {
        console.error('Failed to fetch insight:', err);
        setError('Failed to load insight. Please try again later.');
      } finally {
        setIsLoading(false);
      }
    };
    fetchInsight();
  }, []);
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1250">
      <Header data-id="element-1251" />
      {isLoading ? <main className="flex-grow pt-36 flex items-center justify-center min-h-[60vh]" data-id="element-1252">
          <div className="text-center" data-id="element-1253">
            <LoaderIcon className="w-12 h-12 text-blue-600 animate-spin mx-auto mb-4" data-id="element-1254" />
            <p className="text-gray-600 text-lg" data-id="element-1255">Loading insight...</p>
          </div>
        </main> : error ? <main className="flex-grow pt-36 flex items-center justify-center min-h-[60vh]" data-id="element-1256">
          <div className="text-center" data-id="element-1257">
            <p className="text-red-600 text-lg" data-id="element-1258">{error}</p>
          </div>
        </main> : insightData ? <main className="flex-grow pt-36" data-id="element-1259">
          {/* Insight Content Section */}
          <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8" data-id="element-1260">
            <div className="max-w-4xl mx-auto" data-id="element-1261">
              <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-8 leading-tight" data-id="element-1262">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-1263">
                  {insightData.subject}
                </span>
              </h1>

              {/* Render HTML content */}
              <div className="insight-content-wrapper mb-8" data-id="element-1264">
                <div className="insight-content text-gray-700 leading-relaxed text-lg" dangerouslySetInnerHTML={{
              __html: insightData.content
            }} data-id="element-1265" />
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-1266">
            <div className="max-w-4xl mx-auto text-center" data-id="element-1267">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-1268">
                Ready to stop guessing who's on your list?
              </h2>
              <p className="text-xl text-gray-700 mb-10 max-w-2xl mx-auto" data-id="element-1269">
                Turn your Kit.com data into auto-updating audience segments that
                power better content and better sponsorship deals.
              </p>
              <Link to="/smart-segmentation" className="inline-block px-8 py-4 bg-blue-600 text-white text-lg font-semibold rounded-lg hover:bg-blue-700 transition-colors shadow-lg" data-id="element-1270">
                Learn More
              </Link>
            </div>
          </section>
        </main> : null}

      <Footer data-id="element-1271" />
    </div>;
}